export default __webpack_public_path__ + "static/media/logo-color.f0696881.png";